import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useGroundTeamRatingsSummaryStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        flex: 1,
        overflowy: 'scroll',
        overflowX: 'hidden',
        width: '100%',
    },
    header: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
    },
    tableHeader: {
        minWidth: 'fit-content',
    },
    tableBody: {
        minWidth: 'fit-content',
    },
    tableHeaderRow: {
        height: '44px',
        ...shorthands.padding(0, tokens.spacingHorizontalXL),
        '@media (max-width:640px)': {
            ...shorthands.padding(0, tokens.spacingHorizontalM),
        },
    },
    tableBodyRow: {
        height: '44px',
        cursor: 'pointer',
        ...shorthands.padding(0, tokens.spacingHorizontalXL),
        '@media (max-width:640px)': {
            ...shorthands.padding(0, tokens.spacingHorizontalM),
        },
        '&:hover': { backgroundColor: tokens.colorNeutralBackground2Hover },
        '&:focus-visible': {
            outline: `${tokens.strokeWidthThick} solid ${tokens.colorStrokeFocus2}`,
            outlineOffset: '-1px',
        },
    },
    tableSelectionCell: {
        minWidth: '32px',
        maxWidth: '32px',
    },
    cell: {},
    centeredHeaderCell: {
        textAlign: 'center',
    },
    centeredCell: {
        textAlign: 'center',
    },
    actionCell: {
        '&:active': {
            backgroundColor: 'none',
        },
        '&:hover': {
            backgroundColor: 'none',
        },
    },
    centerContent: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
        gap: '8px',
        textAlign: 'center',
    },
    nameCell: {
        fontWeight: 500,
    },
    ratingCell: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    ratingWrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '12px',
    },
    ratingValue: {
        fontWeight: 500,
        minWidth: '40px',
    },
});
